module.exports = __webpack_public_path__ + "static/media/radio_public.62b5b1ea.jpg";